import Order from './order';

import { getAngleBy2XY } from '../../utils/geometry';


export default class HoldPositionOrder extends Order
{
  constructor()
  {
    super();
    this.color = 'yellow';
  }

  isComplete(): boolean
  {
    return false; // This order keeps on going until another order is given
  }

  onComplete(): void
  {
    return;
  }

  update(modifier: number): HoldPositionOrder
  {
    const element = this.getElement();
    if (!element.canStrafe) // big ships won't try to rotate towards targets
      return this;

    const nearestEnemy = element.getNearestEnemy();
    if (nearestEnemy)
    {
      const destinationAngle = getAngleBy2XY({
        x1: element.x,
        y1: element.y,
        x2: nearestEnemy.x,
        y2: nearestEnemy.y,
      });
      element.rotateTowardsAngle(destinationAngle, modifier);
    }

    return this;
  }
}